import React from "react";
import { FiArrowUpRight } from "react-icons/fi";

const WebsiteFeatureCart = ({ img, heading, title, number }) => {
  return (
    <article className="group relative flex min-h-[290px] flex-col overflow-hidden rounded-[24px] border border-white/10 bg-white/[0.055] p-6 backdrop-blur-xl transition duration-300 hover:-translate-y-1.5 hover:border-[#FFDB16]/35 hover:bg-white/[0.085] hover:shadow-[0_22px_60px_rgba(0,0,0,0.24)] md:p-7">
      <div className="absolute inset-x-0 top-0 h-1 origin-left scale-x-0 bg-gradient-to-r from-[#FFDB16] to-[#239be6] transition-transform duration-300 group-hover:scale-x-100" />

      <div className="flex items-start justify-between gap-4">
        <span className="flex h-16 w-16 items-center justify-center rounded-2xl bg-white shadow-[0_14px_35px_rgba(0,0,0,0.2)]">
          <img
            src={img}
            alt=""
            loading="lazy"
            className="h-11 w-11 object-contain transition-transform duration-300 group-hover:scale-110"
          />
        </span>
        <span className="font-heading text-sm font-extrabold tracking-[0.16em] text-slate-600">
          {number}
        </span>
      </div>

      <h3 className="mt-7 font-heading text-xl font-extrabold leading-tight text-white">
        {heading}
      </h3>
      <p className="mt-3 flex-1 leading-7 text-slate-400">{title}</p>

      <div className="mt-6 flex items-center gap-2 text-xs font-extrabold uppercase tracking-[0.13em] text-[#FFDB16]">
        Built into your experience
        <FiArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
      </div>
    </article>
  );
};

export default WebsiteFeatureCart;
